const ChinaData = require('./china');
const ProvinceData = require('./province');

module.exports = {
  ChinaData, ProvinceData
};



// WEBPACK FOOTER //
// ./src/index.js